module.exports = __webpack_public_path__ + "img/李淼.cdf19756.jpg";